module.exports = __webpack_public_path__ + "img/cabinet_216.d9710ffd.jpg";